import { render, staticRenderFns } from "./RegistrationInfo.vue?vue&type=template&id=23d1f66a&scoped=true&"
import script from "./RegistrationInfo.vue?vue&type=script&lang=ts&"
export * from "./RegistrationInfo.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationInfo.vue?vue&type=style&index=0&id=23d1f66a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1f66a",
  null
  
)

export default component.exports